module.exports = __webpack_public_path__ + "img/dazi_img5.8325852f.png";